import GenericCard from '../../../../components/GenericCards';
import { Col, Row } from 'react-bootstrap';
import Label from '../../../../components/Label';
import Button from '../../../../components/Button';
import Blockquote from '../../../../components/Blockquote';
import React from 'react';

export const AvailableForLoans = () => {
  return (
    <GenericCard variant={'white'}>
      <Row className="align-items-center">
        <Col className={'col-10'}>
          <h5>Available for Loans</h5>
        </Col>
      </Row>
      <Row className="justify-content-between align-content-center align-items-center">
        <Col className={'col-4'}>
          <Label className={'lh-xs text-fw-normal'}>
            <span>Amount</span>
          </Label>
          <h4 className={'text-sm-20-lg-32'}>$49,764.23</h4>
        </Col>
        <Col className={'col-lg-4 col-12'}>
          <Button color={'blue'} className={'w-100'}>
            Take a Loan
          </Button>
        </Col>
      </Row>
      <Row>
        <Col className={'mt-7'}>
          <Blockquote>
            <span className={'text-dark-gray fw-bold'}>If you take a loan</span>
            <ul className="text-dark-gray">
              <li>You can continue to participate in the Plan</li>
              <li>Your Plan balance is temporarily reduced</li>
              <li>You have to repay it, plus interest</li>
              <li>You don't pay taxes if repayments stay on schedule</li>
            </ul>
            <span className={'text-dark-gray fw-bold'}>
              If you take a withdrawal
            </span>
            <ul className="text-dark-gray">
              <li>If you take a withdrawal</li>
              <li>You can continue to participate in the Plan</li>
              <li>Your Plan balance is permanently reduced</li>
              <li>You cannot repay it</li>
              <li>You usually have to pay taxes on it</li>
            </ul>
          </Blockquote>
        </Col>
      </Row>
    </GenericCard>
  );
};
